@if (isUserUnAuthorized) {
  <app-un-authorized [errorStatusCode]="errorStatusCode"></app-un-authorized>
  }@else {
  @if (weavyData) {
    <app-notification-settings [name]="'alerts'"
    [isMobile]="weavyData?.isMobileScreen"></app-notification-settings>
  }
  <div class="alerts" [ngClass]="{'mobile-view': weavyData?.isMobileScreen}">
    <div class="doc-actions">
      <button class="doc-actions-button-container" (click)="notificationSettings()" matTooltip="Notification Settings">
        <img alt="settings" [src]="'images/settings.svg' | assetUrl" class="icon-mr-5" />
        <span class="title" [hidden]="weavyData?.isMobileScreen">Notification Settings</span>
      </button>
    </div>
    <div class="alerts-container" [ngClass]="{'height-auto': weavyData?.isMobileScreen}">
      <div class="alerts-container-header">
        <div class="alerts-container-header-bell">
          <img [class.icon-grey]="allRead" [src]="'images/bell.svg' | assetUrl" alt="unsubscribe icon" />
        </div>

        <div class="search-container">
          <input type="text" [formControl]="searchText" placeholder="Search" autocomplete="off" />
          <span (click)="searchAlerts()" (keypress)="searchAlerts()">
            <img alt="search" [src]="'images/search.svg' | assetUrl" class="search-icon cursor-pointer"
              draggable="false" />
            </span>
          </div>
          <div class="alerts-container-header-markAsRead">
            <!-- <img title="Mark all as read" class="cursor-pointer" [class]="!allRead ? '' : 'icon-grey no-pointer-events'"
            [src]="'images/all-read.svg' | assetUrl" alt="unsubscribe icon" (click)="markAllAsRead()" /> -->
          </div>
        </div>
        @if (alerts.length === 0 && isAlertsDataLoaded) {
          <div class="alerts-container-no-data"> No data found
            {{searchTextData ? "with selected search criteria. Please try with different text." : ""}}
          </div>
        }
        <div class="alerts-container-data" infiniteScroll [infiniteScrollDistance]="5" [infiniteScrollThrottle]="50"
          (scrolled)="onDemandScroll()" [scrollWindow]="false">
          @for (alert of alerts; track alert; let i = $index) {
            <div class="alerts-container-data-card-header"
              [class.alert-read]="alert.read">
              <div class="alerts-container-data-card-header-image" (click)="openUserDetailsDialog(alert.user)" (keypress)="openUserDetailsDialog(alert.user)">
                <span class="cursor-pointer">
                  <!-- <img [src]="'images/user.svg' | assetUrl" alt="user icon" class="user-img" /> -->
                  <app-user-thumb-nail [userEmail]="alert.user.name" class="user-img"></app-user-thumb-nail>
                </span>
              </div>
              <div class="alerts-container-data-card-header-data">
                <div class="user-name" (click)="handleAlertItemClick(alert,i)" (keypress)="handleAlertItemClick(alert,i)">
                  <h6 class="user-name-details" [ngStyle]="{'margin-top': weavyData?.isMobileScreen ? 0 : ''}">
                    {{ alert.user.name }} {{ alert.messageType }}
                  </h6>
                </div>
                <div class="alerts-container-data-card-content" (click)="handleAlertItemClick(alert,i)" (keypress)="handleAlertItemClick(alert,i)">
                  <p class="rte-content" [innerHTML]="alert.messageToDisplay"></p>
                </div>
                <div class="alerts-container-data-card-footer">
                  <span class="alerts-container-data-card-footer-duration" (click)="handleAlertItemClick(alert,i)" (keypress)="handleAlertItemClick(alert,i)">
                    {{ alert.duration }} ago
                  </span>
                  <div class="alerts-container-data-card-footer-read">
                    <!-- (click)="markAsRead(alert,i)"<img title="Mark as read" class="cursor-pointer" [class]="alert.read ? 'icon-grey no-pointer-events' : ''"
                    [src]="'images/read.svg' | assetUrl" alt="unsubscribe icon" /> -->
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
      @if (showLoader) {
        <collaboration-ui-spinner [overlay]="true"></collaboration-ui-spinner>
      }
    </div>
  }